import { template } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorCustomRuleActionItemWebComponent } from '../component/IntegrityMonitorCustomRuleActionItemWebComponent';
import { IntegrityMonitorCustomRuleActionItemView } from '../view/IntegrityMonitorCustomRuleActionItemView';
import { IntegrityMonitorCustomRulesAttribute } from '../../../../common/utils/types';
import { IMConstants } from '../../../../common/utils/IMConstants';

export class IntegrityMonitorCustomRuleActionItemController extends BaseWebComponentController {
  public view!: IntegrityMonitorCustomRuleActionItemView;
  private noActions: boolean;
  private excluded: number[];

  constructor(component: IntegrityMonitorCustomRuleActionItemWebComponent) {
    super(component);

    this.noActions = true;

    this.initialSetup({
      viewConstructor: IntegrityMonitorCustomRuleActionItemView,
      viewTemplate: template,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$checkboxFormField.Input,
        event: 'change',
        callback: this.toggleDropdown,
      },
    ];
  }

  public toggleDropdown() {
    if (!this.noActions) {
      this.view.dom.$dropdownContainer.hidden = !this.view.dom.$checkboxFormField.value;
    }
  }

  public setOptions(opts: IntegrityMonitorCustomRulesAttribute) {
    this.view.dom.$checkboxFormField.Input.label = opts.label;

    if (opts.actions.length > 0) {
      const noAction = {
        label: this.dependencies.translateFn('No action'),
        value: 'no_action',
      };

      this.view.dom.$dropdownFormField.Input.options = [noAction, ...opts.actions].map(action => {
        return {
          title: action.label,
          value: action.value,
        };
      });
      this.view.dom.$dropdownFormField.Input.setFormValue('no_action');

      this.noActions = false;
    }

    this.excluded = opts.excluded ? opts.excluded : [];
  }

  public refreshOptions(os: number | string) {
    if ((this.excluded.length > 0 && os === '') || this.excluded.find(x => x === os)) {
      this.view.dom.$wrapper.hidden = true;

      this.view.dom.$checkboxFormField.discardChanges();
      this.view.dom.$checkboxFormField.resetField();

      this.view.dom.$dropdownFormField.discardChanges();
      this.view.dom.$dropdownFormField.resetField();

      return;
    }

    this.view.dom.$wrapper.hidden = false;
  }
}
